export default (category = '') => category.replace(/\W/g, '').toLowerCase();
